import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet-async';
import {get, isEmpty} from 'lodash';
import {graphql} from 'react-apollo';
import translate from '../../utils/translations';
import updateADL from '../../utils/adl';
import {LoadingError} from '../LoadingError/LoadingError';
import {TripCards} from './TripCards/TripCards';
import {getCancelledTrips, getPastTrips, getUpcomingTrips} from './myTripUtils';
import {MyTripsQuery} from './MyTripsQuery';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import haWrapper from '../../utils/haWrapper';
import {tripCollectionPresented, TRIPS} from '../../utils/edapUtils';
import {TRIP_CONFIG} from './constants';

import './MyTrips.less';

export class MyTrips extends Component {
    static propTypes = {
        systemData: PropTypes.shape({}),
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        systemData: {},
        translations: {},
    };

    componentDidMount() {
        updateADL('travelerdash trips');

        // If SSR failed, retry
        if (!get(this.props, 'data.getTravelerStayList', false)) {
            this.props.data.refetch();
        }
        tripCollectionPresented(TRIPS);
        haWrapper.userTiming.mark('primary.action.rendered');
    }

    render() {
        const {data, systemData, translations} = this.props;
        const trips = data.getTravelerStayList?.travelerStayList || [];
        const {CANCELLED, PAST, UPCOMING} = TRIP_CONFIG;
        const upcomingTrips = getUpcomingTrips(trips);
        const pastTrips = getPastTrips(trips);
        const cancelledTrips = getCancelledTrips(trips);
        const title = (
            <Helmet>
                <title>
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'nav',
                        'th.tabs.booked'
                    )}
                </title>
            </Helmet>
        );

        if (data.loading) {
            return (
                <div className="position-relative" style={{height: '300px'}}>
                    {title}
                    <LoadingOverlay loading />
                </div>
            );
        }

        if (
            data.error ||
            isEmpty(get(data, 'getTravelerStayList.travelerStayList', []))
        ) {
            return (
                <div className="MyTrips container" key="mytrips_error">
                    {title}
                    <LoadingError
                        key="tripCard_error"
                        error={data.error}
                        systemData={systemData}
                        translations={translations}
                    />
                </div>
            );
        }
        return (
            <div className="MyTrips container" key="mytrips_success">
                {title}
                <TripCards
                    heading={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.bookings.upcoming'
                    )}
                    locale={systemData.locale}
                    translations={translations}
                    trips={upcomingTrips}
                    type={UPCOMING.TYPE}
                />
                <TripCards
                    columns={3}
                    heading={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.bookings.past'
                    )}
                    locale={systemData.locale}
                    translations={translations}
                    trips={pastTrips}
                    type={PAST.TYPE}
                />
                <TripCards
                    columns={3}
                    heading={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.bookings.canceled'
                    )}
                    locale={systemData.locale}
                    translations={translations}
                    trips={cancelledTrips}
                    type={CANCELLED.TYPE}
                />
            </div>
        );
    }
}

export default graphql(MyTripsQuery, {options: {errorPolicy: 'all'}})(MyTrips);
